import { MutableRefObject, useEffect, useState } from 'react';

interface UseExpandablePersonalisationOptionsProps {
  wrapperRef: MutableRefObject<HTMLUListElement | null>;
  fourthElementRef: MutableRefObject<HTMLLIElement | null>;
  expandable: boolean;
  minInitialHeight: number;
}

// Calculates unexpanded height using wrapper y - 4th element y
export const useExpandablePersonalisationOptions = ({
  wrapperRef,
  fourthElementRef,
  expandable,
  minInitialHeight,
}: UseExpandablePersonalisationOptionsProps) => {
  const [unexpandedHeight, setUnexpandedHeight] = useState(minInitialHeight);

  useEffect(() => {
    if (expandable) {
      const { y: fourthElementY, height: fourthElementHeight } =
        fourthElementRef.current?.getBoundingClientRect() as DOMRect;

      const { y: wrapperY } = wrapperRef.current?.getBoundingClientRect() as DOMRect;

      if (fourthElementY && wrapperY) {
        setUnexpandedHeight(fourthElementY + fourthElementHeight - wrapperY);
      }
    }
  }, [wrapperRef, fourthElementRef, expandable]);

  return {
    unexpandedHeight,
  };
};
